/**
 * @param {string} url
 * @returns {Promise<void>}
 */
function loadModuleScript(url) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.type = 'module';
        script.src = url;
        script.addEventListener('load', () => resolve(), { once: true });
        script.addEventListener('error', () => reject(new Error(`Failed to load ${url}`)), { once: true });
        document.head.appendChild(script);
    });
}

if (!('popover' in HTMLElement.prototype)) {
    const src = document.querySelector('script[data-popover-polyfill-src]')?.getAttribute('data-popover-polyfill-src');
    if (src) {
        loadModuleScript(src).catch((error) => {
            console.error(error);
        });
    }
}
